import React from 'react';
import { PropTypes } from 'prop-types';
import styles from './PaymentInfo.css';

const PaymentInfo = ({
  drug,
  drugPrice,
  taxPrice,
  od,
  shippingPrice,
  shippingLabel,
}) => (
  <div>
    <div className={od ? styles.odContainer : styles.container}>
      <p>
        {drug}:<span className={styles.right}>${drugPrice.toFixed(2)}</span>
      </p>
      <p>
        {shippingLabel}:
        <span className={styles.right}>
          {shippingPrice === 0 ? 'FREE' : `${shippingPrice.toFixed(2)}`}
        </span>
      </p>
      <p>
        Tax:<span className={styles.right}>${taxPrice.toFixed(2)}</span>
      </p>
      <div className={styles.total}>
        <p>
          TOTAL:
          <span className={styles.right}>
            ${(drugPrice + shippingPrice + taxPrice + 0).toFixed(2)}
          </span>
        </p>
      </div>
    </div>
  </div>
);

PaymentInfo.propTypes = {
  drug: PropTypes.string.isRequired,
  drugPrice: PropTypes.number.isRequired,
  taxPrice: PropTypes.number.isRequired,
  od: PropTypes.bool,
  shippingPrice: PropTypes.number.isRequired,
  shippingLabel: PropTypes.string.isRequired,
};

export default PaymentInfo;



// WEBPACK FOOTER //
// ./src/containers/CartPage/PaymentInfo.jsx